<div class="container-fluid">
    <div class="row top10 no-gutters">
        <div class="col-xs-12 col-md-6 vcenter">
            <h4>Data Cache Management</h4>
        </div>
        <div class="col-xs-12 col-md-6  vcenter-right">
            <div>
            </div>
        </div>
    </div>

    <hr style="margin-top:2px;margin-bottom:2px" />
    <br/>

    <button mat-raised-button color="secondary" (click)="resetCache()">Reset Cache</button>
    
    <div style="margin:8px">
        <div *ngIf="cacheInfo">
            <div>Cache type: {{cacheInfo.isInMemory ? 'In Memory' : 'External'}}</div>
            <div>Environment: {{cacheInfo.environment}}</div>
            <div>Key count: {{cacheKeyCount}}</div>
            <div *ngIf="cacheInfo.isLocal">Running Locally</div>
            <div>Keys:</div>
            <pre>{{cacheKeyData}}</pre>
        </div>
        <div *ngIf="!cacheInfo">{{cacheMessage}}</div>
    </div>

    <!--
    <mat-list>
        <mat-list-item *ngFor="let key of cacheInfo.keys">
            {{key}}
        </mat-list-item>
    </mat-list>
    -->
</div>
